<ca-modal-container modalTitle="Share Image via our Viewer" (dismiss)="dismiss($event)">
    <div class="container">
        <div class="row mb-3">Anyone with the link can view the image.</div>
        <div class="row">
            <span class="text col-md-4 my-2 ps-0 text-center">Shareable link for your image</span>
            <div class="col-md-8 my-3">
                <div class="input-group">
                    <input #urlTextBox class="url-input form-control" type="text" [value]="viewerLink" readonly data-uit="share-url-input" />
                    <button
                        type="button"
                        class="btn btn-secondary"
                        [title]="'GENERAL.COPY_URL_TO_CLIPBOARD' | translate"
                        [ngxClipboard]="urlTextBox"
                        (cbOnSuccess)="t.open()"
                        [ngbTooltip]="'GENERAL.TEXT_COPIED' | translate"
                        triggers="manual"
                        container="body"
                        #t="ngbTooltip"
                    >
                        <ca-icon name="copy" size="s"></ca-icon>
                    </button>
                </div>
            </div>
            <span class="text share-text ps-0 mb-3">
                How would you like to share the link for your image? Please be aware that image links <b class="mx-1">cannot</b> be unshared afterwards.
            </span>
        </div>
        <div class="modal-buttons mt-2">
            <button type="button" class="btn-primary btn me-3" caAutoFocus (click)="openEmail()"><ca-icon name="envelope" size="s"></ca-icon>Mail</button>
            <button type="button" class="btn-secondary btn" (click)="openTwitter()"><ca-icon name="twitter" size="s"></ca-icon>Tweet</button>
        </div>
    </div>
</ca-modal-container>
